//StoreProvider.tsx
import { configureStore } from '@reduxjs/toolkit'
import { Provider } from 'react-redux'
import { ReactNode } from 'react'
import authReducer from '@/features/auth/model/authSlice'
import questionnaireReducer from '@/features/questionnaire/model/questionnaireSlice'
import { baseApi } from '@/shared/api/baseApi'
import nutritionReducer from '@/features/nutrition/model/nutritionSlice';
import trainingReducer from '@/features/training/model/trainingSlice';



export const store = configureStore({
    reducer: {
        auth: authReducer,
        questionnaire: questionnaireReducer,
        [baseApi.reducerPath]: baseApi.reducer,
        nutrition: nutritionReducer,
        training: trainingReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({ serializableCheck: false }).concat(baseApi.middleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export const StoreProvider = ({ children }: { children: ReactNode }) => (
    <Provider store={store}>{children}</Provider>
)
